import React from 'react';
import { clearNexsetSampleDraft } from 'js/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { isEmpty } from 'lodash';
import { TextField, InputAdornment } from '@mui/material';
import NexsetSampleView from '../NexsetSampleView/NexsetSampleView';
import { ReactComponent as CloseIcon } from 'new/components/icons/close-cross.svg';
import { Grid } from '../SchemaSpecGrid';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { ACCUMULATE_SCHEMA_REQUEST } from 'js/constants/actionTypes';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { CenteredLoader } from 'new/elements/CenteredLoader';

const TEXT_FIELD_STYLE = {
  borderRadius: '4px',
  backgroundColor: 'var(--color-greyscale-0)',
};

import s from './NexsetSampleViewGrid.module.scss';

const NexsetSampleViewGrid = ({ dataSet, outputSchema }) => {
  const nexsetSampleDraft = useSelector((state: any) => state.recipeBuilder.nexsetSampleDraft);
  const isLoading = useIsLoading(ACCUMULATE_SCHEMA_REQUEST);
  const dispatch = useAppDispatch();

  return (
    <>
      {isEmpty(nexsetSampleDraft) && <NexsetSampleView data={dataSet} />}

      {isLoading && <CenteredLoader />}

      {!isEmpty(nexsetSampleDraft) && (
        <div className={s.input}>
          <TextField
            size="small"
            fullWidth
            value={nexsetSampleDraft?.name}
            style={TEXT_FIELD_STYLE}
            onChange={() => {}}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  onClick={() => {
                    dispatch(clearNexsetSampleDraft());
                  }}
                >
                  <CloseIcon style={{ cursor: 'pointer' }} />
                </InputAdornment>
              ),
            }}
          />
        </div>
      )}

      <div className="schema-spec-selector-content">
        {!isEmpty(nexsetSampleDraft) && (
          <Grid
            schema={nexsetSampleDraft.schema}
            samples={nexsetSampleDraft.samples}
            rawSchema={nexsetSampleDraft.rawSchema}
            rawSamples={nexsetSampleDraft.rawSamples}
            outputSchema={outputSchema}
            allowSaving
          />
        )}
      </div>
    </>
  );
};

export default NexsetSampleViewGrid;
